import { AppAnalytics, PillClicked } from '../../Analytics';
import { PAGE_NAME } from '../../eventNames';

const pillClickEvents = {
  infoPill: (eventContext) => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(new PillClicked(PAGE_NAME.TASK_DETAIL, '', context));
  },
};

export default pillClickEvents;
